import { PeekFormControl, PeekFormLabel, PeekGrid } from "@piiqtechnologies/ui-components";
import React, { useMemo, useState } from "react";
import AddCustomAmenity from "./AddCustomAmenity";
import Amenity from "./Amenity";
/**
 * AMENITY SELECTOR
 */
const AmenitySelector = ({ label, value, defaultAmenities, onChange, noOfColumns = 1 }) => {
    const [amenities, setAmenities] = useState([...new Set([...defaultAmenities, ...value])]);
    const selectedAmenities = useMemo(() => value, [value]);
    const [customAmenityEditMode, setCustomAmenityEditMode] = useState(false);
    const toggleCustomAmenityEditMode = () => {
        setCustomAmenityEditMode((prev) => !prev);
    };
    /**
     * Adds custom amenities to the list
     * @param newAmenity
     */
    const handleAddAmenity = (newAmenity) => {
        if (newAmenity && !amenities.includes(newAmenity)) {
            setAmenities([...amenities, newAmenity]);
            onChange([...value, newAmenity]);
        }
        toggleCustomAmenityEditMode();
    };
    /**
     * Removes a given amenity from the list
     * @param amenity
     */
    const handleDeleteAmenity = (amenity) => {
        // Delete from displayed amenities list
        if (amenity && amenities.includes(amenity)) {
            setAmenities((amenities) => amenities.filter((_amenity) => amenity !== _amenity));
            onChange(value.filter((_amenity) => amenity !== _amenity));
        }
    };
    /**
     * Handles selection of a given amenity.
     * A selected amneity means it is present in the space
     * @param amenity
     * @param isSelected
     */
    const handleSelectAmenity = (amenity, selected) => {
        if (!defaultAmenities.includes(amenity)) {
            onChange((selected && [...value, amenity]) || value.filter((_amenity) => amenity !== _amenity));
            return;
        }
        onChange((selected && [...value, amenity]) || value.filter((_amenity) => amenity !== _amenity));
    };
    return (React.createElement(PeekFormControl, null,
        label && React.createElement(PeekFormLabel, { bold: true }, label),
        React.createElement(PeekGrid, { container: true },
            amenities.map((amenity) => {
                return (React.createElement(PeekGrid, { item: true, xs: 12 / noOfColumns, key: amenity },
                    React.createElement(Amenity, { custom: !defaultAmenities.includes(amenity), amenity: amenity, selected: selectedAmenities.includes(amenity), onSelect: handleSelectAmenity, onDelete: handleDeleteAmenity })));
            }),
            React.createElement(PeekGrid, { item: true, xs: 4 },
                React.createElement(AddCustomAmenity, { editMode: customAmenityEditMode, handleAddAmenity: handleAddAmenity, toggleEditMode: toggleCustomAmenityEditMode })))));
};
export default AmenitySelector;
